import MenuButtonWrapper from './MenuButtonWrapper';

export default MenuButtonWrapper;